<template>
    <v-chip
        :key="client.ClientSystem.ClientSystemID"
        class="ma-2"
        color="primary"
        text-color="white"
        small
        :close="!clientSystemDeleting"
        @click:close="clientSystemDestroy"
    >
      {{client.ClientName}}
      <v-progress-circular
          v-if="clientSystemDeleting"
          indeterminate
          color="white"
          :width="2"
          :size="15"
      ></v-progress-circular>
    </v-chip>
</template>

<script>
export default {
    name: "ClientSystemChip",

    props: {
        client: Object,
    },
    data() {
      return {
        clientSystemDeleting: false,
      };
    },
    methods: {
        clientSystemDestroy: function () {
            this.clientSystemDeleting = true;

            this.$store.dispatch('clientSystemDestroy', {
                ClientSystem: this.client.ClientSystem,
            }).then(response => {
                if (response.status === 204) {
                    this.$store.commit("showSnackbarSuccess", "Usunięto przypisanie Klienta do Systemu.");
                    this.$emit('clientSystemDestroyed');
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usunięcia przypisanego Klienta do Systemu.");
                }
            })
            .catch(error => {})
            .then(() => {
                this.clientSystemDeleting = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
